import React from 'react';
import styled from '@emotion/styled';

import AddTimelineEntry from '../Timeline/AddTimelineEntry';
import Timeline from '../Timeline/Timeline';

const Entry = styled.li`
  margin: 15px 0 25px;
  position: relative;
`;

const Title = styled.h2`
  border-bottom: 1px solid ${props => props.theme.colors.dark};
  color: ${props => props.theme.colors.dark};
  display: inline-block;
  font-size: ${props => props.theme.size.medium};
  font-weight: 500;
  text-transform: uppercase;
  margin-top: ${props => props.theme.size.small};
  margin-right: 15px;
  padding-right: 100px;
  padding-bottom: ${props => props.theme.size.xsmall};
  width: 100%;

  ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.theme.size.large};
    padding-right: 80px;
  }
`;

const Button = styled.button`
  background-color: transparent;
  border: 0;
  color: ${props => props.theme.colors.dark};
  font-size: ${props => props.theme.size.small};
  display: inline;
  margin-top: ${props => props.theme.size.large};
  margin-right: 15px;
  opacity: 0.5;
  text-decoration: underline;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

class Activity extends React.Component {
  constructor(props) {
    super(props);

    this.removeActivity = this.removeActivity.bind(this);
    this.removeLastEntry = this.removeLastEntry.bind(this);
  }

  removeActivity() {
    let response = window.confirm('You are about to delete "' + this.props.activity.title + '"');
    response && this.props.removeActivity(this.props.activity.title, this.props.activityIndex);
  }

  removeLastEntry() {
    let response = window.confirm('You are about to delete your last entry of "' + this.props.activity.title + '"');
    response && this.props.removeLastEntry(this.props.activity.title, this.props.activityIndex);
  }

  render() {
    return (
      <Entry>
        <Title>{this.props.activity.title}</Title>
        <AddTimelineEntry
          activityIndex={this.props.activityIndex}
          addTimelineEntry={this.props.addTimelineEntry}
          activity={this.props.activity.title}
        />
        <Timeline timeline={this.props.activity.timeline} />
        <Button onClick={this.removeActivity}>Remove Activity</Button>
        { this.props.activity.timeline.length !== 0 &&
          <Button onClick={this.removeLastEntry}>Remove Last Entry</Button>
        }
      </Entry>
    );
  }
}


export default Activity;
